import Header from "../../Components/Header"
import { TextEditor } from "../../Components/TextEditor"
import { useRef, useState, useEffect, useContext } from "react"
import { sendOpenAIPOST } from "../../services/POST";
import { useNavigate } from "react-router-dom";
import _ from 'lodash';
import { StateContext } from '../../services/context';
import { classNames } from "../../utils/utils";
import { BsArrowDownCircle } from 'react-icons/bs';
import { api } from "../../services/POST";

import { LeftArrowIcon, ChangeIcon, InformationIcon, AddCircleIcon } from "../../utils/iconFactory";
import { GenerateButton } from "../../Components/Elements/CustomButtons";
import SelectContentModal from "../../Components/Modals/SelectContentModal";
import HelperModal, {HelperButton} from "../../Components/HelperComponents";
import { TooltipRight } from "../../Components/Elements/Tooltip";
import { EditMoreSettings } from "../../Components/Modals/EditMoreSettings";

export default function Edit() {
  const navigate = useNavigate()
  const {contentType, user} = useContext(StateContext)
  const [inputText, setInputText] = useState("");
  const [avoidedWords, setAvoidedWords] = useState<string[]>([]);
  const [usedWords, setUsedWords] = useState<string[]>([]);
  const [maxChar, setMaxChar] = useState<number>(0)
  
  async function startGeneration() {
    setIsGeneration(true);
    try {
      const data = await api('/getPromptForOpenAI', {
        group: contentType.group, 
        key: contentType.content.key, 
        inputText: inputText,
        avoidedWords: avoidedWords,
        usedWords: usedWords,
        maxChar: maxChar
      })
      await sendOpenAI(data.prompt, data.temp, data.key)
    } catch (err: any) {
      console.log(err)
    }
  }


  const [text, setText] = useState<string>("");
  const [isGeneration, setIsGeneration] = useState<boolean>(false);
  const generationStop = useRef(false)
  
  const autoScroll = useRef(true);
  const [atBottom, setAtBottom] = useState(true);
  const downRef = useRef<HTMLTextAreaElement>(null);

  

  async function sendOpenAI(prompt: string, temp: number, key: string) {
    setText("");
    const { response, controller } = await sendOpenAIPOST(prompt, temp, key);
    const reader = response.body?.getReader();
  
    
    generationStop.current = false
    let accumulatedContent = "";
    if (reader) {
      try {
        while (!controller.signal.aborted) {
          const { done, value } = await reader.read();
          if (done || generationStop.current) break;
          if (autoScroll.current) {scrollToBottom()};
          for (const line of  new TextDecoder("utf-8").decode(value).split("\n")) {
            try {
              const trimmedLine = line.trim();
              if (trimmedLine) {
                const obj = JSON.parse(trimmedLine.replace("data: ", ""));
                const content = _.toString(_.get(obj, "choices.0.delta.content"));
    
                setText((prevLekerdezett) => prevLekerdezett + content);
                accumulatedContent += content;
              }
            } catch (err) {
              console.log("Error:", err);
            }
          }
        }
      } catch (err) {
        console.log("Error in reading loop:", err);
      }
    }

    setIsGeneration(false);
    return accumulatedContent;
  }

  const scrollToBottom = () => {
    if (downRef.current){
      downRef.current.scrollTop = downRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (!downRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = downRef.current;
      setAtBottom(scrollHeight - scrollTop <= clientHeight + 3);
      if (scrollHeight - scrollTop <= clientHeight + 3) autoScroll.current = true;
      else autoScroll.current = false;
    };

    const elem = downRef.current;
    if (elem) {
      elem.addEventListener('scroll', handleScroll);
      return () => elem.removeEventListener('scroll', handleScroll);
    }
  }, []);


  const [openSelectContentModal, setOpenSelectContentModal] = useState<boolean>(false)
  const [helperModalVisible, setHelperModalVisible] = useState<boolean>(false);
  const [openMoreSettings, setOpenMoreSettings] = useState<boolean>(false);
  useEffect(() => {if (user.plan === "standard") {navigate("/")}}, [user.plan])
  return(
    <>
      <Header>
        <div id='edit-custom-header' className="flex items-center justify-center">
          <button id='left-part' className="flex mr-[68px]" onClick={() => navigate('/')}>
            <LeftArrowIcon className="h-5 w-5 mr-2 text-primaryAction fill-current" />
            <p className="text-gray150 text-style-small">Vissza a Főoldalra</p>       
          </button>
          <h2 id='edit-header-text' className="text-textMain text-style-h2">Szöveg generálás és szerkesztő</h2>
          <button id='dummy-element-for-spacing' className="invisible flex ml-[68px]">
            <LeftArrowIcon className="h-5 w-5 mr-2 text-primaryAction fill-current" />
            <p className="text-gray150 text-style-small">Vissza a Főoldalra</p>       
          </button>
        </div>
      </Header>
      
      <div className="flex flex-1 flex-col bg-backgroundWhite h-full relative">
        <EditMoreSettings isVisible={openMoreSettings} onClose={() => setOpenMoreSettings(false)} 
        maxChar={maxChar} setMaxChar={setMaxChar} 
        avoidedWords={avoidedWords} setAvoidedWords={setAvoidedWords}
        usedWords={usedWords} setUsedWords={setUsedWords}/>
        <HelperModal isVisible={helperModalVisible} onClose={() => {setHelperModalVisible(false)}} modalContentType="edit" />
        {!helperModalVisible && (<HelperButton onClick={() => setHelperModalVisible(true)} />)}
        <div id='separator' className="h-[80px]"/>

        <main className="flex flex-1 grid grid-cols-2 w-full divide-x divide-gray10 overflow-hidden relative">
          <SelectContentModal isVisible={openSelectContentModal} onClose={() => setOpenSelectContentModal(false)} />
          <section id='left' className="flex flex-col col-span-1 bg-backgroundWhite p-10">
            <div id='topic-select-flexbox' className="flex flex-col gap-6">
              <h1 className="text-textMain text-style-h3">Add meg a témát és kulcsszavakat</h1>
              <div className="flex">
                <button className="grid grid-cols-2 bg-backgroundDarkGray min-w-[449px] rounded-[16px] p-4" onClick={() => setOpenSelectContentModal(true)}>
                  <div className="flex col-span-1 text-left">
                    <p className="text-textMain text-style-body2">Kiválasztva:</p>
                    <p className="text-gray150 text-style-body2-bold ml-2">{contentType.content.name}</p>
                  </div>
                  <div className="col-span-1 text-right text-primaryAction text-style-body2-bold">
                    <ChangeIcon className="inline-flex h-6 w-6 fill-current mr-2" />
                    Másikat választok
                  </div>
                </button>
                <button id='dummy-element-for-spacing' className="invisible flex-1">
                  -
                </button>
              </div>
            </div>
            <div id='topic-textarea-flexbox' className="pt-10 pb-1 flex flex-col gap-2">
              <div id='header-row' className="flex items-center">
                <p className="text-textMain text-style-body-2">Add meg a terméket vagy a termékkört</p>
                <button className="relative group">
                  <TooltipRight />
                  <InformationIcon className="h-5 w-5 ml-[5px] text-primaryAction fill-current" />
                </button>
              </div>
              <textarea className={classNames("h-[96px] rounded-[12px] bg-backgroundWhite border border-gray100 min-h-[48px] max-h-[192px]",
                "text-textMain text-style-body2 placeholder-gray100",
                "hover:border-primaryActionAltHover",
                "active:border-textMain active:ring-0 active:outline-none focus:border-textMain focus:ring-0 focus:outline-none",
                "disabled:bg-gray0 disabled:border-gray10 disabled:gray40")}
                spellCheck={false}
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
              />
            </div>
            <div id='use-avoid-words-wrapper' className="py-3">
              <button className="flex text-primaryAction" onClick={() => setOpenMoreSettings(true)}>
                <AddCircleIcon className='h-6 w-6 mr-2 fill-current'/>
                <p className="text-style-body2-bold">További beállítások megadása</p>
              </button>
            </div>
            <div id='generate-button-wrapper' className="pt-5" >
              <GenerateButton stopState={isGeneration} onClick={() => {isGeneration ?  generationStop.current = true : startGeneration()}}/>
            </div>
            {/* <div id='generated-text-wrapper' className="flex flex-1 pt-6"> */}
            <div id='generated-text-wrapper' className="flex flex-1 pt-6 relative">
              <textarea className={classNames("w-full rounded-[12px] px-4 py-3 bg-backgroundWhite border border-gray10",
                "text-gray100 text-style-body2 placeholder-gray40",
                "resize-none overflow-y-auto",
                "active:border-textMain active:ring-0 active:outline-none focus:border-textMain focus:ring-0 focus:outline-none",
                "disabled:bg-gray0 disabled:border-gray10 disabled:gray40", (!atBottom && isGeneration) && "bg-custom-gradient")}
                placeholder="Ide fog kerülni az AIDA által írt szöveg."
                spellCheck={false}
                value={text}
                ref={downRef}
              />
              {(!atBottom && isGeneration) && <div className="absolute bottom-5 right-7" ><BsArrowDownCircle className='h-5 w-5 cursor-pointer' onClick={scrollToBottom}/></div>}
            </div>
          </section>
          <TextEditor generated_text={text}/>  
        </main>
      </div>
    </>
  )
}

